<!--~
  ~ Copyright (c) 2010-2024 California CAD Solutions, Inc. Licensed subject
  ~ to an End-User License Agreement included in a separate file named EULA.txt
  ~ that is distributed with this file.
  -->
<div role="group" class='dash-gis-date-range-container f-row'
     [formGroup]="interval"
     [class.dash-gis-date-range-expanded]='interval.value["select"] === "custom"'
     [attr.aria-describedby]="userAriaDescribedBy"
     [attr.aria-labelledby]="parentFormField?.getLabelId()"
     (focusin)="onFocusIn($event)"
     (focusout)="onFocusOut($event)">
    <mat-form-field *ngIf="shouldDisplaySelect">
        <mat-label>{{label}}</mat-label>
        <mat-select #dateSelect (selectionChange)="applySelect($event)">
            <mat-option [value]='{min: undefined, max: undefined}'>-- Select --</mat-option>
            <mat-option *ngFor="let opt of dateOptions" [value]="opt.value">{{opt.text}}</mat-option>
        </mat-select>
    </mat-form-field>
    <ng-container *ngIf="dateSelect?.value === 'custom' || !shouldDisplaySelect">
        <mat-form-field>
            <mat-label *ngIf="!shouldDisplaySelect">{{label}}</mat-label>
            <input matInput #minInput
                   formControlName="min" class='datepicker'
                   [max]="maxInput.value"
                   [matDatepicker]="minPicker" placeholder="From:" />
            <mat-datepicker #minPicker></mat-datepicker>
            <mat-datepicker-toggle matSuffix [for]="minPicker"></mat-datepicker-toggle>
        </mat-form-field>
        <mat-form-field>
            <input matInput #maxInput
                   formControlName="max" class='datepicker'
                   [min]="minInput.value"
                   [matDatepicker]="maxPicker" placeholder="To:" />
            <mat-datepicker #maxPicker></mat-datepicker>
            <mat-datepicker-toggle matSuffix [for]="maxPicker"></mat-datepicker-toggle>
        </mat-form-field>
    </ng-container>
</div>